import { watch } from "vue";
import { useRoute } from "vue-router";

export function usePageTitle(defaultTitle = "PayJoy - Welcome"): void {
  const route = useRoute();
  watch(
    () => route.meta.title,
    (title) => {
      document.title = (title as string) || defaultTitle;
    },
    { immediate: true }
  );
}
